import React from 'react';
import { connect } from 'react-redux';
import { ccsdCodeListFetch, ccsdCodeListUnload } from '../../../lib/redux/actions/ccsdCodes';
import { ccsdCodeCostListFetch, ccsdCodeCostListUnload } from '../../../lib/redux/actions/ccsdCodeCosts';
import { defaultCcsdCodeCostListFetch, defaultCcsdCodeCostListUnload } from '../../../lib/redux/actions/defaultCcsdCodeCost';
import MASpinner from '../../common/MASpinner';
import InvoiceBatchCcsdCodeCostTable from './InvoiceBatchCcsdCodeCostTable';
import { Tab, Tabs } from 'react-bootstrap';
import { consultantTypeCssClass } from '../../../lib/helper/formatting';
import { consultantSingleFetch, consultantSingleUnload } from '../../../lib/redux/actions/consultant';
import { requests } from '../../../lib/helper/agent';

const mapStateToProps = (state) => ({
  ...state.consultantSingle,
  ...state.ccsdCodes,
  ...state.ccsdCodeCosts,
  ...state.defaultCcsdCodeCosts,
});

const mapDispatchToProps = {
  consultantSingleFetch,
  consultantSingleUnload,
  ccsdCodeListFetch,
  ccsdCodeListUnload,
  ccsdCodeCostListFetch,
  ccsdCodeCostListUnload,
  defaultCcsdCodeCostListFetch,
  defaultCcsdCodeCostListUnload,
};

class InvoiceBatchCcsdCodeCostTableContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      loadedConsultantHealthInsurers: [],
      selectedConsultantHealthInsurerIRI: false,
      codeFilter: '',
      currentHealthInsurerId: false,
      selectedInsurerDropdownValue: '',
      ruleDerivedCosts: [],
    };
  }

  setSelectedConsultantHealthInsurer(consultantHealthInsurerId) {
    const iri = '/consultant_health_insurers/' + consultantHealthInsurerId;
    // Always reload on selection - the insurer's bespoke costs may have changed since it was
    // last loaded (e.g. a CcsdCodeCost added on another tab/page), so a stale `loadedConsultantHealthInsurers`
    // entry must not suppress the refetch that keeps the rule-derived-cost fallback below safe.
    this.setState(
      () => ({
        selectedConsultantHealthInsurerIRI: iri,
      }),
      this.loadCcsdCodeCosts,
    );
  }

  componentDidMount() {
    this.props.consultantSingleUnload();
    this.props.ccsdCodeListUnload();
    this.props.ccsdCodeCostListUnload();
    this.props.defaultCcsdCodeCostListUnload();
    this.props.consultantSingleFetch(this.props.consultantId);
  }

  componentWillUnmount() {
    this.props.consultantSingleUnload();
    this.props.ccsdCodeListUnload();
    this.props.ccsdCodeCostListUnload();
    this.props.defaultCcsdCodeCostListUnload();
  }

  loadRuleDerivedCosts() {
    const { consultant } = this.props;
    if (!consultant) return;
    requests
      .get(`/consultants/${consultant.id}/rule-derived-costs`)
      .then((data) => {
        this.setState({ ruleDerivedCosts: Array.isArray(data) ? data : [] });
      })
      .catch(() => {
        this.setState({ ruleDerivedCosts: [] });
      });
  }

  loadCcsdCodes() {
    if (!this.props.consultant || !this.props.consultant.consultantHealthInsurers || this.props.consultant.consultantHealthInsurers.length < 1) {
      return false;
    }

    this.props
      .ccsdCodeListFetch(1, {
        pagination: false,
        'ccsdCodeCosts.consultantHealthInsurer': [
          ...this.props.consultant.consultantHealthInsurers.map((chi) => {
            return chi['@id'];
          }),
        ],
      })
      .then(() => {
        this.loadCcsdCodeCosts();
      });
  }

  componentDidUpdate(prevProps) {
    if (this.props.consultantId !== prevProps.consultantId) {
      this.props.consultantSingleUnload();
      this.props.ccsdCodeListUnload();
      this.props.ccsdCodeCostListUnload();
      this.props.defaultCcsdCodeCostListUnload();
      this.setState({ ruleDerivedCosts: [] });
      this.props.consultantSingleFetch(this.props.consultantId);
      return;
    }
    if (this.props.nextPage !== false && prevProps.nextPage !== this.props.nextPage) {
      this.loadCcsdCodeCosts(this.props.nextPage);
    }
    if (this.props.consultant !== prevProps.consultant) {
      if (this.props.consultant?.id === this.props.consultantId) {
        this.loadCcsdCodes();
        this.loadRuleDerivedCosts();
      }
    }
  }

  fetchDefaultCostsForCode(reference) {
    const { consultant } = this.props;
    if (!consultant || !consultant.consultantHealthInsurers) return;
    const feeAssuredChis = consultant.consultantHealthInsurers.filter((chi) => chi.feeAssured && !chi.healthInsurer.isAnalogue);
    feeAssuredChis.forEach((chi) => {
      this.props.defaultCcsdCodeCostListFetch({
        healthInsurer: chi.healthInsurer['@id'],
        'ccsdCode.reference': reference,
      });
    });
  }

  loadCcsdCodeCosts(page = 1) {
    let consultantHealthInsurersToLoad = this.props.consultant.consultantHealthInsurers
      .filter((chi) => chi.healthInsurer.isAnalogue && !chi.healthInsurer.canHaveOverrideLabel)
      .map((chi) => {
        return chi['@id'];
      });
    if (this.state.selectedConsultantHealthInsurerIRI) {
      consultantHealthInsurersToLoad = [this.state.selectedConsultantHealthInsurerIRI];
      this.setState((prevState) => ({
        loadedConsultantHealthInsurers: prevState.loadedConsultantHealthInsurers.includes(this.state.selectedConsultantHealthInsurerIRI)
          ? prevState.loadedConsultantHealthInsurers
          : [...prevState.loadedConsultantHealthInsurers, this.state.selectedConsultantHealthInsurerIRI],
      }));
    }
    this.props
      .ccsdCodeCostListFetch(
        page,
        {
          consultant: this.props.consultant['@id'],
          pagination: false,
          consultantHealthInsurer: consultantHealthInsurersToLoad,
          //      'ccsdCode': this.props.ccsdCodes.map(ccsdCode => {
          //        return ccsdCode['@id'];
          //      }),
        },
        true,
      )
      .then(() => {
        this.setState(() => ({
          selectedConsultantHealthInsurerIRI: false,
        }));
      });
  }

  render() {
    const { consultant, ccsdCodes, ccsdCodeCosts, isFetchingCcsdCodes, isFetchingCcsdCodeCosts, defaultCcsdCodeCosts, selectedConsultantTypeIri } = this.props;
    //    if (!this.props.consultant || !this.props.consultant.consultantHealthInsurers || this.props.consultant.consultantHealthInsurers.length < 1) {
    //      return (<p>missing data {JSON.stringify({props:this.props})}</p>);
    //    }

    const tableProps = {
      setSelectedConsultantHealthInsurer: (id) => this.setSelectedConsultantHealthInsurer(id),
      consultant,
      ccsdCodes,
      ccsdCodeCosts,
      defaultCcsdCodeCosts: defaultCcsdCodeCosts || [],
      ruleDerivedCosts: this.state.ruleDerivedCosts,
      loadedConsultantHealthInsurers: this.state.loadedConsultantHealthInsurers,
      isFetchingCcsdCodeCosts,
      onCodeFilterSearch: this.fetchDefaultCostsForCode.bind(this),
      reloadCodes: this.loadCcsdCodes.bind(this),
      codeFilter: this.state.codeFilter,
      onCodeFilterChange: (value) => this.setState({ codeFilter: value }),
      currentHealthInsurerId: this.state.currentHealthInsurerId,
      selectedInsurerDropdownValue: this.state.selectedInsurerDropdownValue,
      onHealthInsurerChange: (id, dropdownValue) => this.setState({ currentHealthInsurerId: id, selectedInsurerDropdownValue: dropdownValue }),
    };

    const visibleTypes =
      consultant && selectedConsultantTypeIri
        ? consultant.consultantTypes.filter((ct) => ct['@id'] === selectedConsultantTypeIri)
        : consultant
          ? consultant.consultantTypes
          : [];

    return (
      <div>
        {isFetchingCcsdCodes && <MASpinner />}

        {!isFetchingCcsdCodes && ccsdCodes && ccsdCodes.length > 0 && consultant && visibleTypes.length > 1 && (
          <Tabs variant="tabs" className="px-2 m-0 pt-2" defaultActiveKey={0}>
            {visibleTypes.map((ct, index) => (
              <Tab eventKey={index} key={ct['@id']} title={`${ct.displayName} Costs`} tabClassName={`consultant-type-tab--${consultantTypeCssClass(ct.code)}`}>
                <InvoiceBatchCcsdCodeCostTable {...tableProps} consultantType={ct} />
              </Tab>
            ))}
          </Tabs>
        )}
        {!isFetchingCcsdCodes && ccsdCodes && ccsdCodes.length > 0 && consultant && visibleTypes.length === 1 && (
          <InvoiceBatchCcsdCodeCostTable {...tableProps} consultantType={visibleTypes[0]} />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceBatchCcsdCodeCostTableContainer);

//InvoiceBatchCcsdCodeCostTableContainer.propTypes = {
//  //  consultant: PropTypes.object.isRequired,
//  //  consultantId: PropTypes.object.isRequired,
//};
